export const CLEAR_SELECTION = 'clear_selection';
export const MAINTAIN_SELECTION = 'maintain_selection';
